import React from 'react';
import { any, oneOf, number } from 'prop-types';
import bem from '../../utils/bem';

export const BAR_COLORS = {
    red: 'red',
    black: 'black',
    white: 'white'
};

const SubInfoItem = ({ children, color, index, extraClass, colorCode, isLoading, type, className = '' }) => {
    const properties = { zIndex: 100 - index };
    if (isLoading) {
        properties.opacity = `0`;
    } else {
        properties.opacity = `1`;
    }
    return (
        <div className={`${className} ${bem('subinfo-item', [color, extraClass, type])}`} style={properties}>{children}</div>
    );
};

SubInfoItem.defaultProps = {
    color: BAR_COLORS.red,
    type: 'content'
};

SubInfoItem.propTypes = {
    children: any,
    color: oneOf(Object.keys(BAR_COLORS)),
    colorCode: any,
    index: number
};

export default SubInfoItem
